import { createI18n } from 'vue-i18n';
import en from './en.json';
import frCA from './fr-CA.json';

/**
 * Detect locale from the browser Accept-Language header.
 * Acrobits WebView sets this based on the app's language setting.
 */
function detectLocale(): string {
  const lang = navigator.language || (navigator as unknown as { userLanguage: string }).userLanguage || 'en';
  if (lang.toLowerCase().startsWith('fr')) return 'fr-CA';
  return 'en';
}

const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    'fr-CA': frCA,
  },
});

export default i18n;
